import { render, staticRenderFns } from "./ImportUserCsvDetail.vue?vue&type=template&id=0fa4501e&"
import script from "./ImportUserCsvDetail.vue?vue&type=script&lang=ts&"
export * from "./ImportUserCsvDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports